import * as Yup from "yup";

export const companyPolicySchema = (policies = [], idToExclude = null) =>
  Yup.object().shape({
    policyName: Yup.string()
      .trim()
      .required("Name is required")
      .matches(/^[a-zA-Z ]*$/, "Special characters are not allowed")
      .max(100, "Name must be at most 100 characters")
      .test(
        "no-leading-space",
        "Leading spaces are not allowed",
        (value) => !value || !value.startsWith(" ")
      )
      .test(
        "unique-policy-name",
        "Policy name already exists",
        function (value) {
          if (!value) return true;

          return !policies.some(
            (p) =>
              p.policyName.toLowerCase() === value.trim().toLowerCase() &&
              String(p._id) !== String(idToExclude)
          );
        }
      ),
    description: Yup.string()
      .trim()
      .max(1000, "Description must be at most 1000 characters")
      .optional()
  });
export const companySubPolicySchema = (policies = []) =>
  Yup.object().shape({
    title: Yup.string()
      .trim()
      .required("Name is required")
    ,
    description: Yup.string()
      .trim()
      .required("Description is required")
    ,
    content: Yup.string()
      .trim()
      .test(
        "not-empty-trimmed",
        "Content is required",
        (value) => {
          if (!value) return false;

          const clean = value
            .replace(/<[^>]*>/g, "")   // remove tags
            .replace(/&nbsp;/g, " ")
            .trim();

          return clean.length > 0;
        }
      )
      .required("Content is required")

  });
